export default "__VITE_ASSET__453ff1df__"